import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { contextSchema, ISchemaContext } from "../constants/schemaContext";
import { selectLanguage, useAuthentication, useLoggedInUser } from "../auth/store/authSelectors";
import { EObservationStatus } from "../interfaces/IObservation";
import { useApplicationConfiguration } from "../configuration/ConfigurationContext";
import { useTranslation } from "react-i18next";
import { IFormContext } from "../interfaces/FormContext";
import { useSelector } from "react-redux";
import { FormProps } from "@rjsf/core";

import { FormView, IFormWithRules } from "../../../sg-schema-form";
import ErrorList from "./form/ErrorList";
import extraActions from "../schema/extraActions";
import { EAppLanguages } from "../../../@common/utils/localization";


interface ISchemaForm extends IFormWithRules {
    canViewNames: boolean;
    //  schema: IFormSchema["schema"];
    //  uiSchema: IFormSchema["uiSchema"];
    //  formData?: { [key: string]: any };
    //  rules?: { [key: string]: any }[];
    //  translations?: { [key: string]: any };

}

const SchemaForm: React.FC<ISchemaForm> = ({
    formSchema,
    //  rules = [],
    // schema,
    //  uiSchema,
    formData = {},
    children,
    onSubmit,
    onChange,
    onError,
    liveValidate,
    canViewNames,
    // translations,
    ...otherProps
}) => {

    const config = useApplicationConfiguration();
    // const Form = useMemo(() => config.jsonSchema.getForm(EWidgetType.Write), []);
    const { t, i18n } = useTranslation()

    const [dirtyAfterPageLoad, setDirtyAfterPageLoad] = useState(false);
    const [hasErrors, setHasErrors] = useState(false)

    const handleError = (errors: any[]) => {
        console.log("[SchemaForm.handleError]", { errors })
        setHasErrors(errors.length ? true : false)
        onError && onError(errors);
    }

    const handleSubmit: FormProps<any>["onSubmit"] = (form) => {
        //@ts-ignore
        onSubmit && onSubmit(form);
    }

    const handleChange: FormProps<any>["onChange"] = (form) => {
        console.info("[SchemaForm.handleChange]", form)
        onChange && onChange(form.formData)
        setDirtyAfterPageLoad(true);
    }




    // If there's translations, add them to the namespace
    if (formSchema.translations) {
        const translations = formSchema.translations;
        const keys = Object.keys(translations);
        keys.forEach((key) => {
            i18n.addResourceBundle(key, "schema", translations[key]);
        });
    };

    const user = useLoggedInUser();
    const lang = useSelector(selectLanguage) as EAppLanguages || EAppLanguages.FI;
    const { token, anonymousSession } = useAuthentication();
    const roleList = user ? user.roles.map(({ reference }) => reference).filter((value) => value) : []

    const contextData: ISchemaContext = {
        roles: roleList,
        canViewNames,
        mode: "form",
        status: formData.status || formData.tila || EObservationStatus.New,
        allowChangingProcessingMarkingPublicity: config.allowChangingProcessingMarkingPublicity
    }

    const formContextData: IFormContext = {
        apiToken: token,
        anonymousSession,
        lang,
        dirtyAfterPageLoad
    };
    /*
        const formSchema: IFormSchema = {
            schema: schema as any,
            uiSchema: uiSchema as any,
            rules,
            translations,
            defaultLanguage: lang
        };
    */
    return (
        <FormView
            {...otherProps as any}
            className="ui form SchemaForm"
            ErrorList={ErrorList}

            configurations={config.jsonSchema}
            formSchema={formSchema}
            formData={formData}

            translations={formSchema.translations}

            onSubmit={handleSubmit}
            onChange={handleChange}
            onError={handleError}
            liveValidate={liveValidate || hasErrors}

            contextData={contextData}
            contextSchema={contextSchema as any}

            formContext={formContextData}

            extraActions={extraActions}

            children={children || <Button type="submit"> {t("Tallenna")} </Button>}
        />
    );
};

SchemaForm.defaultProps = {
    noHtml5Validate: true,
    liveValidate: false
}
export default SchemaForm;
